function setProjects(pro){
    //  console.log(episode)
   return {
   
       type:'PROJECTS',
       payload:pro,
   }
   
   }  
   
   
   
   export default setProjects;
   
   
   